export default __webpack_public_path__ + "static/magnifier-ecff7897a0f3e336295f743d0027d594.mp4";